export function GetInitialsName(name: string): string {
  if (!name || typeof name !== 'string') return 'LS';

  // Match all Unicode letters at the start of words
  const matches = name.match(/\p{L}/gu); // \p{L} = any kind of letter from any language (emoji-safe)

  const initials = matches?.slice(0, 2).join('').toUpperCase();

  return initials && initials.length > 0 ? initials : 'LS';
}
